import { render, staticRenderFns } from "./BaseProgressCircle.vue?vue&type=template&id=4d72ec3c&scoped=true&"
import script from "./BaseProgressCircle.vue?vue&type=script&lang=js&"
export * from "./BaseProgressCircle.vue?vue&type=script&lang=js&"
import style0 from "./BaseProgressCircle.vue?vue&type=style&index=0&id=4d72ec3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72ec3c",
  null
  
)

export default component.exports